import React from 'react'
import { Route } from 'react-router-dom'

import MarketingOptIn from './MarketingOptIn'

export default [
  <Route key='/marketing-opt-in' path='/marketing-opt-in' component={MarketingOptIn} />
]



// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/routes.js